import React from 'react';

import { connect } from 'react-redux'

// import { setItem } from '../../helpers/session'

class Component extends React.Component  {

  render() {
    return (      
      <button 
        type="button" 
        class={"btn btn-sm primary btn-aff-toggle btn-block "+this.props.className}
        onClick={e => {e.preventDefault(); this.props.sublogin(this.props.aid,this.props.user.aid)}}>
        Login
      </button>            
    )
  }

}

import api from '../../actions/api'

export default connect(function(state){
  return {
    apiState: state.api.auth_autologin || state.api.initial,
    user: state.session.user
  }
}, {
  api,
  sublogin: function(aid,oldAid) {
    return function(dispatch) {
      dispatch({
        type: "api",
        key: "auth_logout",
        keepSid: true,
        aid: oldAid,
        pathname: location.pathname
      })
      api("auth/autologin",{
        id: aid,
        sublogin: true
      })(dispatch)
    }  
  }
})(Component);